import store from '@/scripts/store';
import { addScript } from '@/scripts/async';
import { getProfile } from '@/scripts/api/account';
import { isFunction } from '@/scripts/utils';
import { clearAll } from '@/scripts/utils/store-dependent';
import { validateEmail } from '@/scripts/utils/regex';
import { getRef } from '@/scripts/utils/dom';
import { get as getKey } from 'lodash';
import { flagNameFromCountry } from '@/scripts/utils';

/*  */
const {
  VUE_APP_GOOGLE_RECAPTCHA_SCRIPT_URL: recaptchaScriptUrl,
  VUE_APP_GOOGLE_RECAPTCHA_KEY: recaptchaKey,
} = process.env;

function goTo(to, params = {}) {
  const { $route: route } = this;
  const { method = 'push' } = params;
  const { path } = route;

  if (to === path) return;

  this.$router[method](to);
}

function initGoogleReCaptcha() {
  const url = `${recaptchaScriptUrl}?onload=__onGoogleReCaptchaLoad&render=explicit`;

  return new Promise((resolve, reject) => {
    addScript(url)
      .then(() => {
        window.__onGoogleReCaptchaLoad = resolve;
      })
      .catch(reject);
  });
}

function processGoogleReCaptcha() {
  const { $refs: refs } = this;

  Object.entries(refs).forEach(([key = '', nodeCandidate]) => {
    const [, name] = key.split('recaptcha-');

    const node = getRef(nodeCandidate);

    if (node) {
      const id = window.grecaptcha.render(node, {
        sitekey: recaptchaKey,
        callback: captcha => this.onRecaptchaVerified(captcha, id, name, node),
      });
    } else {
      console.warn(`no node to bind recaptcha | refs =`);
      console.dir(refs);
      console.dir(nodeCandidate);
    }
  });
}

function checkCloseModalMenu() {
  const { showModalMenu } = store.state;

  if (showModalMenu) store.dispatch('toggleModalMenu');
}

function updateUser(callback) {
  return getProfile()
    .then(user => {
      store.dispatch('setUser', user);

      if (isFunction(callback)) callback();
    })
    .catch(clearAll);
}

function setSaveState(state = 'saved') {
  const isError = state instanceof Error;

  if (isError) {
    this.saveState = 'error';

    return;
  } else if (state === 'saved') {
    setTimeout(() => {
      this.saveState = null;
    }, 2000);
  }

  this.saveState = state;
}

function errorCloseCallback() {
  this.$router.push('/sign-up');
}

function handleError(e) {
  console.warn(`oauth error = ${e} | payload = `);
  console.dir(this.payload);
  clearAll();

  this.setErrorCloseCallback(this.errorCloseCallback);

  /* async */
  this.redirectId = setTimeout(() => {
    this.setError(null);
    this.$router.push('/sign-up');
  }, 5000);
}

function checkEmailValid(email = this.email) {
  const result = validateEmail(email);

  return result;
}

function setAsyncInputError(text) {
  this.validFlagId = setTimeout(() => {
    const onCheckError = this.checkEmailValid(this.email) ? null : text;

    this.emailError = onCheckError;
  }, 2000);
}

function emitClick(name) {
  const { $refs: refs } = this;
  const nodeCandidate = refs[name];

  const button = getRef(nodeCandidate);

  if (!button || !button.click) {
    console.warn(`no node "${name}" in refs |`);
    console.dir(refs);
    return;
  }

  button.click();
}

function checkValidAndEmitClick(name) {
  const { isFormValid } = this;

  if (!isFormValid) return;

  this.emitClick(name);
}

function setPagesCount(data = {}) {
  const { total, perPage } = data;
  const result = Math.ceil(total / perPage);

  this.pages = result;

  return result;
}

function getLeaderboardRowValue(allData, field, params = {}) {
  const { subField = 'displayName', units = '' } = params;
  const data = getKey(allData, field);

  if (data && field === '_player') {
    const subValue = data[subField];

    if (subField === 'country') {
      const flagName = flagNameFromCountry(subValue);

      return flagName;
    }

    if (subField === 'displayName') {
      /* Remove trailing hash for games such as Modern Warfare or Warzone */
      return subValue.replace(/#.+/, '');
    }

    return subValue;
  }

  const result = `${data}${field !== '_rank' && units ? ` ${units}` : ''}`;

  return result;
}

export {
  goTo,
  checkCloseModalMenu,
  initGoogleReCaptcha,
  updateUser,
  processGoogleReCaptcha,
  setSaveState,
  errorCloseCallback,
  handleError,
  checkEmailValid,
  setAsyncInputError,
  emitClick,
  checkValidAndEmitClick,
  setPagesCount,
  getLeaderboardRowValue,
};
